import { INTRODUCED_BY } from '@src/types/attribution';
import { BooleanSelection } from '@src/types/index';
import { FindStatus } from '@src/types/oneTouchSwitching';
import type { Title, YourDetailsFormValues } from '@src/types/yourDetails';

const initialValues: YourDetailsFormValues = {
  aboutNameTitle: '' as Title,
  aboutNameFirst: '',
  aboutNameLast: '',
  aboutDoB: '',
  aboutContactNumber: '',
  aboutEmail: '',
  aboutAddressRecent: BooleanSelection.No,
  aboutAddressPreviousOwner: BooleanSelection.No,
  aboutPreviousAddress: {},

  yaPassword: '',
  yaAdditionalAccount: BooleanSelection.No,
  yaAdditionalAccountNameTitle: '',
  yaAdditionalAccountNameFirst: '',
  yaAdditionalAccountNameLast: '',
  yaAdditionalAccountDoB: '',
  yaAdditionalAccountContactNumber: '',
  yaAdditionalAccountEmail: '',
  yaSecondCbcAccount: BooleanSelection.No,
  yaSecondCbcUseDetails: BooleanSelection.No,
  yaSecondCbcNameTitle: '' as Title,
  yaSecondCbcNameFirst: '',
  yaSecondCbcNameLast: '',
  yaSecondCbcDoB: '',
  yaSecondCbcContactNumber: '',
  yaSecondCbcEmail: '',

  ddName: '',
  ddSortCode: '',
  ddAccountNumber: '',
  ddBillingSame: BooleanSelection.Yes,
  ddBillingAddress: undefined,
  ddBillingAddressForm: {},

  broadbandEmergMonitDevice: undefined,
  broadbandEmergAlt: undefined,

  otsHasExistingLine: true,
  otsProviderNotListed: false,
  otsSelectedProvider: null,
  otsFindStatus: FindStatus.NOT_STARTED,
  otsComms: [],
  otsHomePhoneSuffix: null,
  otsAccountReference: '',
  otsBroadbandReference: '',
  otsHomePhoneReference: null,
  otsFieldErrors: [],
  otsMatchId: null,
  otsSwitchingReference: null,
  otsSwitchOptions: [],

  introducedBy: INTRODUCED_BY.NONE,
  customerReferral: '',
  connectorReferral: '',
  partnerReferral: '',
  rlAcceptMarketing: BooleanSelection.Yes,
  rlTermsAccept: BooleanSelection.No,

  renewalBroadbandDate: null,
  renewalMobileDate: null,
  renewalHomeInsuranceDate: null,
  renewalCarInsuranceDate: null,
};

export { initialValues };
